import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../../../context';
import { useStoriesByChannelIdQuery } from '../../../services';
import { FilterValue, SelectItem } from '../../components';
import { useFilter } from './useFilter';

interface UseCardStoryFilterArgs {
  filter: FilterValue[];
}

export const useCardStoryFilter = ({ filter }: UseCardStoryFilterArgs) => {
  const { t } = useTranslation();

  const { channelId } = useContext(UserContext).userInfo.userData;

  const { data: stories, isFetching } = useStoriesByChannelIdQuery({ channelId });

  const { getGroupValue } = useFilter();

  const options = useMemo(() => {
    return (
      stories?.map(({ id, title }) => {
        return { id, title } as SelectItem;
      }) ?? []
    );
  }, [stories]);

  const dropdown = useMemo(() => {
    return {
      disabled: isFetching,
      options,
      staticListPosition: false,
      search: true,
      multiCheck: true,
    };
  }, [isFetching, options]);

  return {
    group: {
      id: 'story',
      title: t('storiesFilter.title'),
      value: getGroupValue({ filter, groupId: 'story', multiCheck: true, propToMap: 'id' }) ?? [],
      dropdown,
    },
  };
};
